import {useAuthedQuery} from '../../../../../common/hooks/QueryHooks';
import {CampaignSlots} from '../../create/types/Types';

const useCampaignSlots = () => {
	const {data, refetch} = useAuthedQuery<CampaignSlots>('/enterpriser/campaign/slots');
	return {
		data,
		refetch,
	};
};

export default useCampaignSlots;
